/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_Chatbot_DescInputs */

const en_privacy_section_2_item_chatbot_desc = /** @type {(inputs: Privacy_Section_2_Item_Chatbot_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`messages you send to our AI assistant, which are processed by OpenAI to generate responses`)
};

const lv_privacy_section_2_item_chatbot_desc = /** @type {(inputs: Privacy_Section_2_Item_Chatbot_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ziņas, ko sūtāt mūsu AI asistentam, kuras apstrādā OpenAI, lai ģenerētu atbildes`)
};

/**
* | output |
* | --- |
* | "messages you send to our AI assistant, which are processed by OpenAI to generate responses" |
*
* @param {Privacy_Section_2_Item_Chatbot_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_chatbot_desc = /** @type {((inputs?: Privacy_Section_2_Item_Chatbot_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_Chatbot_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_chatbot_desc(inputs)
	return en_privacy_section_2_item_chatbot_desc(inputs)
});